import React from "react";
import { Form, Col, Row } from "react-bootstrap";

export function PersonnelServiceInfoForm({ 
  handleChange,
  values
}) {
  return (
    <div className="row">
      <div className="col-4">
        <Form.Group as={Row} controlId="serviceYear">
          <Form.Label column sm={5}>
            Hizmet Yılı
          </Form.Label>
          <Col sm={7}>
            <Form.Control type="number" min={0} value={values.serviceYear} placeholder="Hizmet Yılı" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>

      <div className="col-4">
        <Form.Group as={Row} controlId="workingYearInTheSchool">
          <Form.Label column sm={5}>
            Okuldaki Çalışma Yılı
          </Form.Label>
          <Col sm={7}>
            <Form.Control type="number" min={0} value={values.workingYearInTheSchool} placeholder="Okuldaki Çalışma Yılı" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>
      
      <div className="col-4">
        <Form.Group as={Row} controlId="yearOfSeniority">
          <Form.Label column sm={5}>
            Kıdem Yılı
          </Form.Label>
          <Col sm={7}>
            <Form.Control type="number" min={0} value={values.yearOfSeniority} placeholder="Kıdem Yılı" onChange={handleChange} />
          </Col>
        </Form.Group>
      </div>
    </div>
  );
}